import { useCallback } from 'react'

import { capitalize } from 'lodash'
import { AccordionList, AccordionListContainer, AccordionListContent, AccordionListItem, AccordionListTrigger, List } from 'twyne-new.ui'

import { useBuilderStore } from '@/components/builder/utils/store'
import { usePalette } from '@/modules/cms/views/post/components/builder/context'

import DraggableAssetItem, { UnavailableAssetItem } from './DraggableAssetItem'
import VariantAssetItem from './VariantAssetItem'

export default function Assets({ floatbarRef }) {
  const isEditingBlockLevel = useEditingBlockLevel()
  const palette = usePalette()

  return <>
    <AccordionListContainer>
      <AccordionList type='multiple' defaultValue={['Content', 'Layout', 'Structures', 'Form', 'Dynamic', 'Embedded', 'Containers']}>
        {palette.map(({ items, name }, idx) => <AccordionListItem value={name} key={idx}>
          <AccordionListTrigger>{capitalize(name)}</AccordionListTrigger>
          <AccordionListContent>
            <List>
              {items.map((item, idx) => {
                const { variants, level } = item

                if (isEditingBlockLevel(level)) {
                  return <UnavailableAssetItem key={idx} item={item} />
                }

                if (variants) {
                  return <VariantAssetItem key={idx}
                    item={item}
                    floatbarRef={floatbarRef}
                  />
                }

                return <DraggableAssetItem key={idx}
                  item={item}
                />
              })}
            </List>
          </AccordionListContent>
        </AccordionListItem>)}
      </AccordionList>
    </AccordionListContainer >
  </>
}

export function useEditingBlockLevel() {
  const { postBuilder: { item } = {} } = useBuilderStore()
  const { level } = item || {}

  return useCallback(assetLevel => {
    if (!level || !assetLevel) {
      return false
    }

    return level !== assetLevel
  }, [level])
}
